import { z } from "zod";

const toText = (value) => {
  if (value == null) return "";
  if (typeof value === "number") return String(value);
  return value;
};

const requiredText = (label) =>
  z.preprocess(
    toText,
    z
      .string({ required_error: `${label} is required` })
      .trim()
      .min(1, `${label} is required`)
  );

export const Step6Schema = z.object({
  bodilyInjury: requiredText("Bodily injury limits"),
  umbi: z.boolean().default(false),
  umPropertyDamage: requiredText("UM/UIM property damage"),
  medPay: requiredText("Med pay"),
  pip: requiredText("PIP"),
  compDeductible: requiredText("Comp deductible"),
  collisionDeductible: requiredText("Collision deductible"),
  paymentPlan: requiredText("Payment plan"),
  runClue: z.boolean().default(false),
});
